exports.list = {
    path: '/jadwal_teknisi',
    name: 'jadwal_teknisi_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/jadwal_teknisi/List.vue"),
}
exports.show = {
    path: '/jadwal_teknisi/show/:id',
    name: 'jadwal_teknisi_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/jadwal_teknisi/Show.vue"),
}